import * as React from 'react';

const InfoChunkyRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
        <circle cx={12} cy={12} r={10} stroke="#324EFC" strokeWidth={2} />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 18h-2v-8h2v8zM12 6a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
            fill="#324EFC"
        />
    </svg>
);

InfoChunkyRebrandingSvg.displayName = 'InfoChunkyRebrandingSvg';
export default InfoChunkyRebrandingSvg;
